var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 11.35c0-4.997 0-7.495 1.552-9.048C3.855.75 6.353.75 11.35.75h5.3c4.997 0 7.495 0 9.048 1.552 1.552 1.553 1.552 4.051 1.552 9.048v5.3c0 4.997 0 7.495-1.552 9.048-1.553 1.552-4.051 1.552-9.048 1.552h-5.3c-4.997 0-7.495 0-9.048-1.552C.75 24.145.75 21.647.75 16.65v-5.3z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36 19H4.867V8.497h4.39c.994 0 1.775.236 2.343.706.568.466.851 1.104.851 1.914 0 .554-.18 1.046-.538 1.478-.36.432-.803.689-1.332.771v.132c.708.067 1.283.334 1.725.8.441.461.662 1.034.662 1.718 0 .922-.322 1.65-.968 2.183-.64.534-1.521.801-2.642.801zM6.745 9.99v2.925H8.56c.664 0 1.169-.123 1.513-.371.35-.252.525-.616.525-1.092 0-.46-.158-.82-.474-1.077-.315-.257-.757-.386-1.324-.386H6.746zm0 7.518H8.93c.694 0 1.22-.138 1.58-.415.358-.281.538-.689.538-1.223 0-.524-.187-.922-.56-1.193-.37-.272-.913-.408-1.631-.408h-2.11v3.239zm10.292-4.498h.32l3.945-4.513h2.154l-4.505 5.11L23.792 19h-2.314l-4.113-4.498h-.327V19H15.16V8.497h1.878v4.513z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 14,
    y1: 0.75,
    x2: 14,
    y2: 27.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026FF7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.e448991165c7faa41cfc206b28eb4a59.svg";
export { ForwardRef as ReactComponent };